<div class="flex justify-between items-center">
  <app-line-details [line]="line" [showLineCity]="true" (onLineClick)="onPickFavoriteClick.emit()"/>

  @if (!!showActionButtons) {
    <div class="flex items-center">
      <!--
        a11y: pen/trash icon buttons render only a glyph (aria-hidden), so we
        must supply an explicit accessible name; otherwise mot-button has
        nothing to set aria-label from and screen readers announce them as
        unnamed "button, dialog". Names are passed from the parent
        manage-favorites which owns the language subscription.
      -->
      <mot-button matType="icon" icon="pen" [ariaLabel]="editAriaLabel" ariaHaspopup="dialog" (onClick)="onEditButtonClick.emit()" />
      <mot-button matType="icon" icon="trash" [ariaLabel]="deleteAriaLabel" ariaHaspopup="dialog" (onClick)="onDeleteButtonClick.emit()" />
    </div>
  }
</div>